import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import moment from 'moment'

import { apiUrl } from '../../../../config'

import SearchPost from './search'
import CheckError from '../../../../utils/admin/checkError'
import NotificationVerify from '../../../../utils/admin/notificationVerify'
import Toast from '../../../../components/Toast'

const $ = require('jquery')
$.DataTable = require('datatables.net')

class ListReportPost extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            isAdmin: false,
            isEditor: false,
            isAuthor: false,
            isContributor: false,
            isAs: '',
            loadingRole: true,
            requestData : {},
            searchData: {
                title: "",
                user_id: "",
                user_name: "",
                category_id: "",
                category_name: "",
                typeList: "all",
                createdAtMonth: '',
                createdAtYear: '',
                limit: 5
            },
            createdDate: "",
            author: null,
            category: null,
            urlDownloadExcel: "",
        }
        this.refreshPosts = this.refreshPosts.bind(this)
        this.handleClickMonthBox = this.handleClickMonthBox.bind(this)
        this.onChangeSearch = this.onChangeSearch.bind(this)
        this.onChangeInput = this.onChangeInput.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
    }

    handleClickMonthBox(e) {
        this.refs.pickAMonth.show()
    }

    componentDidMount() {
        const user = JSON.parse(this.props.localUser);
        setTimeout(() => this.loadDatas(user.id))
    }

    onChangeInput(name, value) {
        this.setState({ [name] : value });
    }

    onChangeSearch(e) {
        const { name, value } = e.target
        let { searchData } = this.state;
        searchData[name] = value;
        if (name === "limit") {
            this.setState({ searchData });
            if(value !== 'All') {
                $('#datatable-report-post').DataTable().page.len(value)
            } else {
                $('#datatable-report-post').DataTable().page.len(-1)
            }
        } else {
            this.setState({ searchData });
        }
    }

    handleSubmit(e) {
        const {requestData} = this.state
        const route = '/report/posts?sort_field=' + (requestData.sort_field ? requestData.sort_field : '') +
            '&sort_by=' + (requestData.sort_by ? requestData.sort_by : '') +
            '&page=' + (requestData.page ? requestData.page : '') +
            '&limit=' + (requestData.limit ? requestData.limit : '') +
            '&keyword=' + (requestData.keyword ? requestData.keyword : '') +
            '&state_id=' + (requestData.state_id ? requestData.state_id : '') +
            '&category_id=' + (requestData.category_id ? requestData.category_id : '') +
            '&createdAtMonth=' + (requestData.createdAtMonth ? requestData.createdAtMonth : '') +
            '&createdAtYear=' + (requestData.createdAtYear ? requestData.createdAtYear : '') +
            '&schedule=0&user_id=' + (requestData.user_id ? requestData.user_id : '');
        const url = `${apiUrl}${route}`;
        this.setState({urlDownloadExcel : url})
        return true;
    }

    loadDatas(user_id) {
        const {
            isAs
        } = this.props

        var _ = this
        var forTitle = this.props.title
        const route = `${
            forTitle === 'Nitizen Jurnalism'
                ? '/post/get_by_category'
                : '/post/index'
            }`
        const url = `${apiUrl}${route}`
        this.$el = $(this.el)
        var postDatatableDraw = 1
        let searchParams = new URLSearchParams(_.props.location.search);
        var page = searchParams.get('page') && !isNaN(searchParams.get('page')) ? Number(searchParams.get('page')) : 1;
        var limit = searchParams.get('limit') && !isNaN(searchParams.get('limit')) ? Number(searchParams.get('limit')) : 5;
        var start = (page - 1) * limit ? (page - 1) * limit : 0;
        var sort_field = 0;
        var sort_by = searchParams.get('sort_by') && searchParams.get('sort_by') == 'ASC' ? 'asc' : 'desc';

        if (searchParams.get('sort_field') && searchParams.get('sort_field') == "state_id") {
            sort_field = 4;
        } else if (searchParams.get('sort_field') && searchParams.get('sort_field') == "createdAt") {
            sort_field = 5;
        } 
        
        this.$el.DataTable({
            processing: true,
            scrollX: true,
            serverSide: true,
            order: [[sort_field, sort_by]],
            pageLength: limit,
            displayStart: start,
            lengthChange: false,
            searching: false,
            searchDelay: 1000,
            processing: true,
            ajax: {
                url: url,
                headers: {
                    'x-access-token': _.props.token
                },
                data: function (data) {
                    var requestData = {}
                    postDatatableDraw = data.draw;

                    if (data.order && data.order[0] && data.order[0].column === 4) {
                        requestData.sort_field = "state_id";
                    } else if (data.order && data.order[0] && data.order[0].column === 5) {
                        requestData.sort_field = "createdAt";
                    } else {
                        requestData.sort_field = "id";
                    }

                    if (data.order && data.order[0] && data.order[0].dir === "desc") {
                        requestData.sort_by = "DESC";
                    } else {
                        requestData.sort_by = "ASC";
                    }

                    requestData.page = data.start / data.length + 1
                    requestData.limit = data.length
                    requestData.keyword = _.state.searchData.title
                    requestData.state_id = _.state.searchData.typeList
                    requestData.category_id = _.state.searchData.category_id
                    requestData.createdAtMonth = _.state.searchData.createdAtMonth
                    requestData.createdAtYear = _.state.searchData.createdAtYear
                    requestData.schedule = 0
                    if (['admin', 'editor'].indexOf(isAs) > -1) {
                        requestData.user_id = _.state.searchData.user_id
                    } else {
                        requestData.user_id = user_id
                    }
                    if (forTitle == 'Nitizen Jurnalism') {
                        requestData.category = 'netizen-journalist'
                    }
                    _.setState({requestData});
                        
                    return requestData
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    // Do something here
                    if(jqXHR && jqXHR.responseJSON) { CheckError(jqXHR.responseJSON) }
                    else { Toast('Error internet connection') }
                },
            },
            columns: [
                {
                    data: null,
                    name: 'id',
                    render: function (data) {
                        var id = data.id
                        if (forTitle == 'Nitizen Jurnalism') {
                            id = data.post.id
                        }
                        return ( id )
                    }

                },
                {
                    data: null,
                    name: 'title',
                    orderable: false,
                    width: '250px',
                    render: function (data) {
                        var id = data.id
                        var title = data.title
                        if (forTitle == 'Nitizen Jurnalism') {
                            id = data.post.id
                            title = data.post.title
                        }
                        return ( title )
                    }
                },
                {
                    data: null,
                    name: 'name',
                    orderable: false,
                    searchable: false,
                    render: function (data) {
                        return forTitle == 'Nitizen Jurnalism'
                            ? data.post.user.name
                            : data.user.name
                    }
                },
                {
                    data: null,
                    name: 'categories',
                    orderable: false,
                    searchable: false,
                    render: function (data) {
                        if (forTitle == 'Nitizen Jurnalism') {
                            var categories = ''
                            var total = data.post.categoryables.length
                            data.post.categoryables.map(function (item, key) {
                                categories += item.category.name
                                categories =
                                    key + 1 < total
                                        ? categories + ', '
                                        : categories
                            })
                            return categories
                        } else {
                            var categories = ''
                            var total = data.categoryables.length
                            data.categoryables.map(function (item, key) {
                                categories += item.category.name
                                categories =
                                    key + 1 < total
                                        ? categories + ', '
                                        : categories
                            })
                            return categories
                        }
                    }
                },
                {
                    data: null,
                    name: 'status',
                    render: function (data) {
                        return forTitle == 'Nitizen Jurnalism'
                            ? data.post.state.name
                            : data.state.name
                    }
                },
                {
                    data: null,
                    name: 'createdAt',
                    render: function (data) {
                        var createdDate = moment(
                            forTitle == 'Nitizen Jurnalism'
                                ? data.post.createdAt
                                : data.createdAt
                        ).format('DD/MM/YYYY HH:mm')
                        return createdDate
                    }
                }
            ]
        })
    }

    refreshPosts() {
        $('#datatable-report-post')
            .DataTable()
            .ajax.reload()
    }

    render() {
        return (
            <div className="col-lg-9 col-12">
                <NotificationVerify isAs={this.props.isAs} localUser={this.props.localUser}>
                    <div className="entry card card-input">
                        <div className="row">
                            <div className="col-12">
                                <div className="mt-3">
                                    <h4 className="heading-title">
                                        {this.props.title} List
                                    </h4>
                                    <div>
                                        <SearchPost
                                            searchData={this.state.searchData}
                                            createdDate={this.state.createdDate}
                                            author={this.state.author}
                                            category={this.state.category}
                                            isAs={this.props.isAs}
                                            token={this.props.token}
                                            title={this.props.title}
                                            location={this.props.location}
                                            onChangeSearch={this.onChangeSearch}
                                            refreshPosts={this.refreshPosts}
                                            onChangeInput={this.onChangeInput}
                                        />
                                    </div>
                                    <table
                                        id="datatable-report-post"
                                        className="display table table-sm table-striped table-bordered"
                                        width="100%"
                                        ref={el => (this.el = el)}
                                    >
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>Title</th>
                                                <th>Author</th>
                                                <th>Categories</th>
                                                <th>Status</th>
                                                <th>Date</th>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                            </div>
                            <div className="col-12 text-right">
                                <div className="form-group">
                                    <form action={this.state.urlDownloadExcel} method="post" onSubmit={this.handleSubmit}> 
                                        <input type="hidden" name="x-access-token" value={this.props.token} />
                                        <button
                                            style={{ marginTop: "27px" }}
                                            className="btn btn-md btn-color btn-button"
                                        >
                                            Download Excel
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </NotificationVerify>
            </div>
        )
    }
}

export default ListReportPost
